import React from 'react';
import style from './style.scss';
import {DateTime} from 'components/UI/DateTime';
import {Link} from 'react-router-dom';
import {UploadImage} from 'components/UI/Image';

class TradeNewsItem extends React.Component {
  constructor(props, context) {
    super(props, context);
    this.state = {

    }
  }

  render() {
    return (
      <div className="trade-news">
        <div className='trade-news-left-content'>
          <Link to={`/tin-tuc/${this.props.slug}/${this.props.id}`} className='product-link'>
            <UploadImage transform="crop" className='product-image' width="440" height="200" type="ARTICLE" image={this.props.image}/>
          </Link>
        </div>
        <div className='trade-news-right-content'>
          <h2 className='title'><Link className='title-link' to={`/tin-tuc/${this.props.slug}/${this.props.id}`}>{this.props.title}</Link></h2>
          <p className='description'>{this.props.description}</p>
          <p className='time'><DateTime dateTime={this.props.updatedAt}/></p>
        </div>
      </div>
    );
  }
}

TradeNewsItem.defaultProps = {
  link: '',
  image: '',
  name: '',
  description: '',
  time: ''
}

export default TradeNewsItem;



// WEBPACK FOOTER //
// ./components/partials/tradenews/TradeNewsItem.jsx